export const build = { date:"2026-05-22.1337", stage:"alpha" }
